import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import usePrivateLink from "../../config/usePrivateLink";

// import usePrivateLink from "../../config/usePrivateLink";
// import { useNavigate, useLocation } from "react-router-dom";

// const UserHeader = ({ data }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const tabs = [

//     { id: "Source List", title: "User List", icon: "fa-solid fa-list", path: "/settings/users" },
//     { id: "AddStudent", title: "Role List", icon: "fa-solid fa-file-circle-plus", path: "/role" },
//     { id: "studentList", title: "Role Management Add", icon: "fa-solid fa-eye", path: "/settings/user/add_new_role" },
//   ];

//   return (
//     <div className="">

//       {/* ✅ Sidebar Menu */}
//       <div className="list-group shadow-sm mb-3" style={{ minWidth: "260px" }}>
//         <h5 className="text-primary text-center p-2">{data}</h5>
//         {tabs.map((tab) => {
//           const isActive = location.pathname === tab.path;

//           return (
//             <button
//               key={tab.id}
//               className={`list-group-item list-group-item-action d-flex align-items-center ${
//                 isActive ? "active" : ""
//               }`}
//               onClick={() => navigate(tab.path)}
//             >
//               <i className={`${tab.icon} me-2`} />
//               {tab.title}
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default UserHeader;





const UserHeader = ({ data }) => {
  const hasAccess = usePrivateLink();
  const navigate = useNavigate();
  const location = useLocation();
const tabs = [

    { id: "Source List", title: "User List",     icon: "ri-list-check-2",  path: "/settings/users" },
    { id: "AddStudent", title: "Role List", icon: "ri-file-add-line",  path: "/role" },
    { id: "studentList", title: "Role Management Add", icon: "ri-eye-line",     path: "/settings/user/add_new_role" },
  ];


  const filteredTabs = tabs.filter((tab) => hasAccess(tab.path));


  return (
    <div className="">

      {/* ✅ Sidebar Menu */}
      <div className="list-group shadow-sm mb-3" style={{ minWidth: "260px" }}>
        <h5 className="text-primary text-center p-2">{data}</h5>
        {filteredTabs.length === 0 && (
          <div className="text-center text-danger">You don't have permission to access any tabs.</div>
        )}
        {filteredTabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          const permission = hasAccess(tab.path);

          return (
            <button
              key={tab.id}
              className={`list-group-item list-group-item-action d-flex align-items-center ${isActive ? "bg-label-primary" : ""} ${!permission ? "disabled-tab" : ""}`}
              onClick={() => permission && navigate(tab.path)}
              style={{
                cursor: permission ? "pointer" : "not-allowed",
                color: !permission ? "red" : "inherit",
                backgroundColor: !permission ? "#f8d7da" : "inherit",
              }}
              disabled={!permission}
            >
              <i className={`${tab.icon} me-2`} />
              {tab.title}
            </button>
          );
        })}
      </div>

      {/* ✅ Page Content */}
    </div>
  );
};

export default UserHeader;










